/**
 * Step 5: Data de Nascimento
 * Coleta a data de nascimento do usuário
 */

import React, { useState } from 'react';
import { StepContainer, FormFieldGroup, StepNavigation } from '../components';
import { StepProps, useFormContext } from '../context';
import { useFormValidation } from '../hooks';
import { validateDate } from '../validators';

const Step5_DataNascimento: React.FC<StepProps> = ({ onNext, onPrevious, data, isLoading }) => {
  const { updateFields } = useFormContext();
  const [localData, setLocalData] = useState({ dateOfBirth: data.dateOfBirth || '' });
  const [errors, setErrors] = useState<Record<string, string>>({});

  const formatDate = (value: string): string => {
    const cleaned = value.replace(/\D/g, '');
    const match = cleaned.match(/(\d{0,2})(\d{0,2})(\d{0,4})/);
    
    if (!match) return value;
    
    let formatted = '';
    if (match[1]) formatted = match[1];
    if (match[2]) formatted += `/${match[2]}`;
    if (match[3]) formatted += `/${match[3]}`;
    
    return formatted;
  };

  const handleChange = (value: string) => {
    const formatted = formatDate(value);
    setLocalData({ dateOfBirth: formatted });
    setErrors({});
  };

  const handleNext = () => {
    const validation = validateDate(localData.dateOfBirth);
    
    if (!validation.valid) {
      setErrors({ dateOfBirth: validation.error || 'Data inválida' });
      return;
    }
    const [day, month, year] = localData.dateOfBirth.split('/').map(Number);
    const birthDate = new Date(year, month - 1, day);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    if (age < 18) {
      setErrors({ dateOfBirth: 'Você deve ser maior de 18 anos' });
      return;
    }

    updateFields(localData);
    onNext(localData);
  };

  return (
    <StepContainer
      title="Qual sua data de nascimento?"
      description="No formato DD/MM/YYYY"
    >
      <FormFieldGroup
        label="Data de Nascimento"
        error={errors.dateOfBirth}
        required
      >
        <input
          type="text"
          placeholder="15/08/1990"
          value={localData.dateOfBirth}
          onChange={(e) => handleChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-[#5c5c5c]"
        />
      </FormFieldGroup>

      <StepNavigation
        onNext={handleNext}
        onPrevious={onPrevious}
        isLoading={isLoading}
        showPrevious={true}
      />
    </StepContainer>
  );
};

export default Step5_DataNascimento;
